module.exports = __webpack_public_path__ + "static/blog17-e022ae37b1ab092f69727e3f9e82326a.png";